import { render, staticRenderFns } from "./SpacerBlock.vue?vue&type=template&id=209eff1c&scoped=true"
import script from "./SpacerBlock.vue?vue&type=script&lang=js"
export * from "./SpacerBlock.vue?vue&type=script&lang=js"
import style0 from "./SpacerBlock.vue?vue&type=style&index=0&id=209eff1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209eff1c",
  null
  
)

export default component.exports